import { useMemo } from "react";
import { Cell, Pie, PieChart } from "recharts";

import { RechartPieChartData } from "@helpers/charts";
import { pluralize } from "@helpers/string";

const EngagementSurveyQuestionNpsChart = ({
  data,
}: {
  data: RechartPieChartData[];
}) => {
  const total = useMemo(
    () => data.reduce((sum, entry) => sum + entry.value, 0),
    [data]
  );
  const npsScore = useMemo(() => {
    const promoterVal = data.find((entry) =>
      entry.name.toLocaleLowerCase().includes("promoter")
    );
    const detractorVal = data.find((entry) =>
      entry.name.toLocaleLowerCase().includes("detractor")
    );
    if (!promoterVal || !detractorVal) {
      return 0;
    }
    return (
      Math.round((promoterVal.value / total) * 100) -
      Math.round((detractorVal.value / total) * 100)
    );
  }, [data, total]);
  return (
    <div className="bg-gray-50 rounded-md p-6 flex items-center justify-center gap-12">
      <div className="flex flex-col items-center gap-2">
        <div className="text-sm text-gray-500">eNPS Score</div>
        <div className="text-5xl font-bold">{npsScore}</div>
      </div>

      <div>
        <PieChart width={100} height={100}>
          <Pie
            data={data}
            startAngle={90}
            endAngle={-270}
            cx="50%"
            cy="50%"
            innerRadius={30}
            outerRadius={50}
            dataKey="value"
          >
            <>
              {data.map((entry) => (
                <Cell key={`cell-${entry.name}`} fill={entry.color} />
              ))}
            </>
          </Pie>
        </PieChart>
      </div>

      <table>
        <tbody>
          {data.map((entry) => (
            <tr key={entry.name}>
              <td className="py-1 px-1">
                <div
                  className="rounded h-3 w-3"
                  style={{ backgroundColor: entry.color }}
                ></div>
              </td>
              <td className="py-1 px-1 font-semibold">
                {Math.round((entry.value / total) * 100) + "%"}
              </td>
              <td className="py-1 px-3">{entry.name}</td>
              <td className="py-1 px-3 text-sm text-gray-500">{`${
                entry.value
              } ${pluralize("response", entry.value)}`}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EngagementSurveyQuestionNpsChart;
